import React from 'react';

import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { itemsVisibleUnderTimelineFilter } from 'Shared/helpers';
import { ItemType, SelectorValue } from 'Shared/constants/types';

import TimelineItemsTable from './TimelineItemsTable/TimelineItemsTable';
import './TimelineGroupItem.scss';

type Props = {
  label: string;
  weeksAgo: number;
  groupTimelineFilterValue: SelectorValue;
};

function TimelineGroupItem({ label, weeksAgo, groupTimelineFilterValue }: Props) {
  const discussionTopics = useDeepEqualSelector(state =>
    itemsVisibleUnderTimelineFilter({
      items: state.workspace.discussion_topics,
      weeksAgo,
      groupBy: groupTimelineFilterValue.value,
    })
  );
  const actionItems = useDeepEqualSelector(state =>
    itemsVisibleUnderTimelineFilter({
      items: state.workspace.meeting_items,
      weeksAgo,
      groupBy: groupTimelineFilterValue.value,
    })
  );

  return (
    <div className="timeline-group-item border w-100 my-4 pb-3">
      <div className="timeline-group-item-header d-flex justify-content-between border-bottom">
        <div className="timeline-group-item-header-label my-2  ml-3">{label}</div>
      </div>
      <div className="px-3">
        <TimelineItemsTable items={discussionTopics} listType={ItemType.discussionTopic} />
        <TimelineItemsTable items={actionItems} listType={ItemType.actionItem} />
      </div>
    </div>
  );
}

export default TimelineGroupItem;
